<template>
  <div>
    <PageContent :dataList="listData" title="质检信息" ref="pageContentRef">
      <template v-slot="itemData">
        <div class="qs">
          <div class="swipe-wrap">
            <img
              src="@/assets/images/left.png"
              @click="handleSwipeChange(`swipe${itemData.itemData.ts}`, 'prev')"
              alt=""
            />
            <van-swipe class="swipe" :ref="`swipe${itemData.itemData.ts}`">
              <van-swipe-item
                v-for="(item, index) in itemData.itemData.op.op.picurl.split(
                  ','
                )"
                :key="index"
              >
                <img :src="item" alt="" @click="switch_image(item)" />
              </van-swipe-item>
            </van-swipe>
            <img
              src="@/assets/images/right.png"
              @click="handleSwipeChange(`swipe${itemData.itemData.ts}`, 'next')"
              alt=""
            />
          </div>
          <div class="item">
            检测机构: <span>{{ itemData.itemData.op.op.organ_name }}</span>
          </div>
          <div class="item">
            检测人: <span>{{ itemData.itemData.op.op.check_username }}</span>
          </div>
        </div>
      </template>
    </PageContent>
  </div>
</template>

<script>
import { ImagePreview } from "vant";

export default {
  data() {
    return {
      // listData: {},
      images: [],
      listData: {},
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    // const {data:res} = await this.$api.getDataApi()
    // console.log(res.chainReport);
    // this.options = res.chainReport
    this.defaultId = this.$route.query.defaultId;
    this.listData = JSON.parse(localStorage.getItem("idInObj"))[4];
    // if (this.listData) {
    //   this.isShowPage();
    // }

    // this.options = getItem.v
    // console.log(this.options )
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  //方法
  methods: {
    handleSwipeChange(v, type) {
      console.log(v, type);
      this.$refs[v][type]();
      // this.$nextTick(() => {
      //   this.$refs.swipe.next();
      //   console.log(this.$refs.swipe.next);
      //   this.$forceUpdate();
      // });
    },
    isShowPage() {
      if (this.listData.msgItems) {
        setTimeout(() => {
          this.$refs.pageContentRef.flagBoxFather();
          setTimeout(() => {
            this.$refs.pageContentRef.titleChildSwitch(
              0,
              this.listData.msgItems[0].txid
            );
          });
        }, 500);
      }
    },
    switch_image(img) {
      ImagePreview([img]);
    },
  },
};
</script>
<style lang="scss" scoped>
.qs {
  padding: 0 20px;
  .swipe-wrap {
    margin-bottom: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 512px;
    img {
      width: 32px;
      height: 64px;
    }
    .swipe {
      width: 366px;
      height: 512px;
      .van-swipe-item {
        box-sizing: border-box;
        padding: 10px;
        background-color: #e3e3e3;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .item {
    display: flex;
    margin-bottom: 56px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 38px;
    color: #222222;
    span {
      margin-left: 10px;
      width: 370px;
      color: #808080;
    }
  }
}
</style>
